"use strict";
// THIS FILE IS AUTO-GENERATED BY THE ANALYTICS CODEGEN SCRIPT
// DO NOT MANUALLY MODIFY THIS FILE
// FOR MORE INFORMATION CHECK OUT: https://github.com/flexapp/genoa/pull/5762
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
exports.AnalyticsV2 = void 0;
var BillConnectEventsImport = __importStar(require("./bill-connect"));
var ChargebackEventsImport = __importStar(require("./chargeback"));
var CommonEventsImport = __importStar(require("./common"));
var CookieConsentManagementEventsImport = __importStar(require("./cookie-consent-management"));
var EmbedEventsImport = __importStar(require("./embed"));
var FlexAnywhereEventsImport = __importStar(require("./flex-anywhere"));
var HelpMenuEventsImport = __importStar(require("./help-menu"));
var MartechOnboardingFunnelEventsImport = __importStar(require("./martech-onboarding-funnel"));
var ModalNavigationEventsImport = __importStar(require("./modal-navigation"));
var NavigationEventsImport = __importStar(require("./navigation"));
var OnboardingEventsImport = __importStar(require("./onboarding"));
var OnboardingBillConnectEventsImport = __importStar(require("./onboarding-bill-connect"));
var OnboardingCreateAccountPrefillEventsImport = __importStar(require("./onboarding-create-account-prefill"));
var OnboardingMoveInEventsImport = __importStar(require("./onboarding-move-in"));
var OnboardingP2PEventsImport = __importStar(require("./onboarding-P2P"));
var P2PEventsImport = __importStar(require("./P2P"));
var PrefillsEventsImport = __importStar(require("./prefills"));
var ReferralsEventsImport = __importStar(require("./referrals"));
var RelinkBillConnectEventsImport = __importStar(require("./relink-bill-connect"));
var ThreeDSecureWebviewEventsImport = __importStar(require("./three-d-secure-webview"));
var AnalyticsV2;
(function (AnalyticsV2) {
    AnalyticsV2.P2PEvents = P2PEventsImport;
    AnalyticsV2.BillConnectEvents = BillConnectEventsImport;
    AnalyticsV2.ChargebackEvents = ChargebackEventsImport;
    AnalyticsV2.CommonEvents = CommonEventsImport;
    AnalyticsV2.CookieConsentManagementEvents = CookieConsentManagementEventsImport;
    AnalyticsV2.EmbedEvents = EmbedEventsImport;
    AnalyticsV2.FlexAnywhereEvents = FlexAnywhereEventsImport;
    AnalyticsV2.HelpMenuEvents = HelpMenuEventsImport;
    AnalyticsV2.MartechOnboardingFunnelEvents = MartechOnboardingFunnelEventsImport;
    AnalyticsV2.ModalNavigationEvents = ModalNavigationEventsImport;
    AnalyticsV2.NavigationEvents = NavigationEventsImport;
    AnalyticsV2.OnboardingP2PEvents = OnboardingP2PEventsImport;
    AnalyticsV2.OnboardingBillConnectEvents = OnboardingBillConnectEventsImport;
    AnalyticsV2.OnboardingCreateAccountPrefillEvents = OnboardingCreateAccountPrefillEventsImport;
    AnalyticsV2.OnboardingMoveInEvents = OnboardingMoveInEventsImport;
    AnalyticsV2.OnboardingEvents = OnboardingEventsImport;
    AnalyticsV2.PrefillsEvents = PrefillsEventsImport;
    AnalyticsV2.ReferralsEvents = ReferralsEventsImport;
    AnalyticsV2.RelinkBillConnectEvents = RelinkBillConnectEventsImport;
    AnalyticsV2.ThreeDSecureWebviewEvents = ThreeDSecureWebviewEventsImport;
})(AnalyticsV2 = exports.AnalyticsV2 || (exports.AnalyticsV2 = {}));
